import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { LoadingContext } from "../contexts/LoadingContext";
// import { getDistributorDetails } from '../services/distributor/DistributorApi';
import { errorToast } from "../utils/helper-ui";
import {
  createDistributor,
  getDistributors,
  updateDistributor,
} from "../services/distribution/DistributorApi";
import { SearchContext } from "../contexts/SearchContext";
import { PaginationResponse } from "../objects/pagination";
import { Checkbox, IconButton, Pagination, Table } from "rsuite";
// import { Distributor } from '../models/distributor';
import PlusIcon from "@rsuite/icons/Plus";
import { Distributor } from "../models/distribution/distributor";
import { getPagination } from "../utils/helper";
import DistributorForm from "../components/features/distribution/DistributorForm";
const { Column, HeaderCell, Cell } = Table;
interface DistributorPageProps {}

const DistributorPage: FC<DistributorPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [companies, setCompanies] = useState<Distributor[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState<Distributor>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === companies.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < companies.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? companies.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    fetchData();
  }, [mounted]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getDistributors({ page, size, search });
      const resJson = await res.json();
      // setDistributor(data);
      setCompanies(resJson.data.items);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Distributor</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Distributor
        </IconButton>
      </div>
    </div>
  );

  const saveDistributor = async (distributor: Distributor) => {
    try {
      setIsLoading(true);
      if (selectedDistributor) {
        await updateDistributor(selectedDistributor.id!, distributor);
      } else {
        await createDistributor(distributor);
      }
      setModalFormOpen(false);
      setSelectedDistributor(undefined);
      fetchData();
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout header={renderHeader()}>
      <Table minHeight={700} data={companies} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size +
                  companies.indexOf(rowData as Distributor) +
                  1}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable fixed>
          <HeaderCell>Distributor Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedDistributor(rowData as Distributor);
                  setModalFormOpen(true);
                }}
              >
                {rowData.name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Address</HeaderCell>
          <Cell dataKey="address" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Phone</HeaderCell>
          <Cell dataKey="phone" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Website</HeaderCell>
          <Cell dataKey="website" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Email</HeaderCell>
          <Cell dataKey="email" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Contact Person</HeaderCell>
          <Cell dataKey="contact_person" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Contact Position</HeaderCell>
          <Cell dataKey="contact_position" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Contact Title</HeaderCell>
          <Cell dataKey="contact_title" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Contact Note</HeaderCell>
          <Cell dataKey="contact_note" />
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div>
      <DistributorForm
        distributor={selectedDistributor}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedDistributor(undefined);
        }}
        onSubmit={saveDistributor}
      />
    </MainLayout>
  );
};

export default DistributorPage;
